import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 17c0 -6.075 -5.373 -11 -12 -11","key":"svg-0"}],["path",{"d":"M3 3v18h18","key":"svg-1"}]]

/**
 * IconChartPpf
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hhcnQtcHBmIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOSAxN2MwIC02LjA3NSAtNS4zNzMgLTExIC0xMiAtMTEiIC8+CiAgPHBhdGggZD0iTTMgM3YxOGgxOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chart-ppf
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChartPpf = createReactComponent('outline', 'chart-ppf', 'ChartPpf', __iconNode);

export default IconChartPpf;